import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SfAccordionSummary, SfLocationLabelText } from './Filter.style';

import { useEffect, useState } from 'react';
import { FacetState } from '@coveo/headless';

const StudyTypeFilter = (props: any): JSX.Element => {
  const { controller, showMoreText, showLessText, clearAllText, noFacetsText } = props;
  const [state, setState] = useState<FacetState>(controller.state);

  const onClearAll = () => controller.deselectAll();

  useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);

  return (
    <Grid item sx={{ marginTop: '1rem' }}>
      <Accordion disableGutters defaultExpanded={false}>
        <SfAccordionSummary
          expandIcon={
            <ChevronRightIcon
              sx={{
                color: (theme) => theme.palette.neutral8.main,
                height: '32px',
                width: '32px',
              }}
            />
          }
          aria-controls="study-type-content"
          id="study-type-header"
        >
          <SfLocationLabelText>{props?.fields?.heading?.value}</SfLocationLabelText>
        </SfAccordionSummary>

        {state.hasActiveValues && (
          <Typography
            onClick={onClearAll}
            component="div"
            color="error.main"
            sx={{
              marginLeft: '16px',
              '&:hover': { cursor: 'pointer', textDecoration: 'underline' },
            }}
          >
            {clearAllText}
          </Typography>
        )}

        <AccordionDetails>
          {state && state.values.length ? (
            state?.values?.map((value) => (
              <div key={value?.value}>
                <FormControlLabel
                  sx={{ color: (theme) => theme.palette.neutral9.main }}
                  key={value.value}
                  label={`${value.value} (${value.numberOfResults} results)`}
                  control={
                    <Checkbox
                      checked={controller.isValueSelected(value)}
                      onChange={() => controller.toggleSelect(value)}
                      disabled={state.isLoading}
                    />
                  }
                />
              </div>
            ))
          ) : (
            <span>{noFacetsText}</span>
          )}
        </AccordionDetails>
        {state.canShowMoreValues && (
          <Button onClick={() => controller.showMoreValues()}>{showMoreText}</Button>
        )}
        {state.canShowLessValues && (
          <Button onClick={() => controller.showLessValues()}>{showLessText}</Button>
        )}
      </Accordion>
    </Grid>
  );
};

export default StudyTypeFilter;
